// A map that defines the events that might occur on an agent chat
const EventType = {
  NEW_CHAT: { id: 'NEW_CHAT' },
  SWITCHED_ACTIVE_CHAT: { id: 'SWITCHED_ACTIVE_CHAT' },
  INCOMING_MESSAGE: { id: 'INCOMING_MESSAGE' },
  OUTGOING_MESSAGE: { id: 'OUTGOING_MESSAGE' },
  AI_FOLLOWUP_MESSAGE: { id: 'AI_FOLLOWUP_MESSAGE' },
  AGENT_PICKED_UP_CHAT: { id: 'AGENT_PICKED_UP_CHAT' },
  AGENT_CLOSED_CHAT: { id: 'AGENT_CLOSED_CHAT' },
  MESSAGE_SENT: { id: 'MESSAGE_SENT' },
  MESSAGE_READ: { id: 'MESSAGE_READ' },
  CONTACT_CLOSED_CHAT: { id: 'CONTACT_CLOSED_CHAT' },
  CONTACT_LEFT_CHAT: { id: 'CONTACT_LEFT_CHAT' },
  REOPENED_CHAT: { id: 'REOPENED_CHAT' },
  OUT_MESSAGE_DELIVERY_CONFIRMED: { id: 'OUT_MESSAGE_DELIVERY_CONFIRMED' },
  OUT_MESSAGE_DELIVERY_FAILED: { id: 'OUT_MESSAGE_DELIVERY_FAILED' },
  OUT_MESSAGE_RECEIPT: { id: 'OUT_MESSAGE_RECEIPT' },
  OUT_MESSAGE_READ: { id: 'OUT_MESSAGE_READ' },
  IN_MESSAGE_DELIVERY_CONFIRMED: { id: 'IN_MESSAGE_DELIVERY_CONFIRMED' },
  IN_MESSAGE_DELIVERY_FAILED: { id: 'IN_MESSAGE_DELIVERY_FAILED' },
  IN_MESSAGE_READ: { id: 'IN_MESSAGE_READ' },
  XFER_REQUESTED: { id: 'XFER_REQUESTED' },
  XFER_CANCELLED: { id: 'XFER_CANCELLED' },
  XFER_REJECTED: { id: 'XFER_REJECTED' },
  RESUME_REQUESTED: { id: 'RESUME_REQUESTED' },
  XFER_ACCEPTED: { id: 'XFER_ACCEPTED' },
  CHAT_FORCED_ASSIGNED_TO_AGENT: { id: 'CHAT_FORCED_ASSIGNED_TO_AGENT' },
  NEW_CONVERSATION: { id: 'NEW_CONVERSATION' },
  NEW_AUTOMATIC_MESSAGE: { id: 'NEW_AUTOMATIC_MESSAGE' },
  CHAT_PIN_TOGGLED: { id: 'CHAT_PIN_TOGGLED' },
  INCOMING_REACTION: { id: 'INCOMING_REACTION' },
  CHAT_TAKEN: { id: 'CHAT_TAKEN' },
  CHAT_TAKEN_MESSAGE: { id: 'CHAT_TAKEN_MESSAGE' },
  CHAT_ASSIGNED: { id: 'CHAT_ASSIGNED' },
  CHAT_ASSIGN_MESSAGE: { id: 'CHAT_ASSIGN_MESSAGE' },
  NO_ANSWER_FROM_AGENT: { id: 'NO_ANSWER_FROM_AGENT' },
  // The contact shared their phone through a REQUEST_CONTACT_INFO request and it was linked (ENG-1304)
  CONTACT_PHONE_LINKED: { id: 'CONTACT_PHONE_LINKED' },
};

export default EventType;
